import React, { useEffect, useState } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Alert } from "reactstrap";
import Layout from "../../components/Wrappers/Layout";
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import BackButton from "../../components/BackButton/BackButton";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import SaveIcon from "@mui/icons-material/Save";
// import SearchIcon from "@mui/icons-material/Search";
import { partnerAddUpdateNotificationConfigLists } from "../../redux/actions/addUpdateNotificationConfigPartnerAction";
import { getNotificationConfigsAdminList } from "../../redux/actions/getNotificationConfigAdminAction";
import { getWalletOwnerIdAndNameList } from "../../redux/actions/getWalletOwnerIdAndNameListAction";
import { getPartnerWalletRoles } from "../../redux/actions/partnerWalletRolesAction";
import { getWalletAcRequired } from "../../redux/actions/walletAcRequiredAction";
import { addUpdateNotificationConfigAdminLists } from "../../redux/actions/addUpdateNotificationConfigAdminAction";
import val from "../../getThemeDetails";

const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});

const AdminPushNotification = () => {
    const classes = useStyles();

    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );

    //partnerWalletRoles

    const rolesOnWalletOwnerRes = useSelector(
        ({ partnerWalletRoles }) => partnerWalletRoles
    );


    var authToken = regenerateTokenRes.data.AuthToken;

    const location = useLocation();
    const dispatch = useDispatch();

    const [role, setRole] = useState("");
    const [walletRole, setWalletRole] = useState(role);
    const [notificationOpen, setNotificationOpen] = useState(false);
    const [checkListNotification, setCheckListNotification] = useState(false)
    const [walletOwner, setWalletOwner] = useState("");
    const [walletOwnerTableStatus, setWalletOwnerTableStatus] = useState(false);
    const [walletOwnerTableArray, setWalletOwnerTableArray] = useState([]);

    const [addOrEditStatus, setAddOrEditStatus] = useState("add")
    const [rolesOnWalletOwner, setRolesOnWalletOwner] = useState([])

    const [getDataCompare, setGetDataCompare] = useState([])


    // const [getMainArr, setGetMainArr] = useState(["LOAD", "SEND", "PURCHASE", "REFUND", "RECEIVED"])
    const getOwnerAndNameList = useSelector(
        ({ getWalletOwnerIdAndNameList }) => getWalletOwnerIdAndNameList
    );
    const getWalletRolesRes = useSelector(
        ({ walletAcRequired }) => walletAcRequired
    );

    const getAddUpdateNotificationConfigAdminRes = useSelector(
        ({ addUpdateNotificationConfigurationAdminLists }) => addUpdateNotificationConfigurationAdminLists
    );
    // const getUpdateNotificationConfigRes = useSelector(
    //     ({ partnerAddUpdateNotificationConfigsLists }) => partnerAddUpdateNotificationConfigsLists
    // );
    const getNotificationConfigsAdminRes = useSelector(
        ({ adminGetnotificationConfigLists }) => adminGetnotificationConfigLists
    );
    // 
    console.log("selector1", getNotificationConfigsAdminRes);
    const [getCongigNotificStatus, setGetCongigNotificStatus] =
        useState(false);
    const [getCongigNotificResArray, setGetCongigNotificResArray] =
        useState("");

    const handleChange = ({ target: { name, value } }) => {
        // setGetMainArr([...defaultArr])
        console.log(name, value);
        if (name === "role") {

            setRole(value == "Select Role" ? "" : value);

            handleSearch(value)
        }

        if (name === "walletRole") {
            setWalletRole(value);
        }


    }

    const WalletAcRequiredFunc = (walletOwnerId) => {
        const WalletAcRequired = {
            authentication: {
                partnerId: walletOwnerId.split("-")[0]
            },
        };

        return dispatch(getWalletAcRequired(WalletAcRequired, authToken));
    };



    const handleChangeWallet = ({ target: { name, value } }) => {
        setGetMainArr([...defaultArr])
        if (name === "walletOwner") {
            setWalletOwner(value == "Select Owner ID" ? "" : value);
            // getRolesOnWalletOwnerReq(value)
            WalletAcRequiredFunc(value)

        }
    };
    // const [getNoneNotification, setGetNoneNotification] = useState('')
    // const [getPushNotification, setGetPushNotification] = useState('');
    // const [getEmailNotification, setGetEmailNotification] = useState('');
    // const [getSmsNotification, setGetSmsNotification] = useState('');
    // const [getTransType, setGetTransType] = useState('')

    const handleNoticationClose = () => {
        setNotificationOpen(false);
        // setCheckListNotification(false);

    };

    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            getWalletOwnerIdAndNameListTableRequest();
            // getWalletOwnerIdAndNameListApiReq();
        }
    }, [regenerateTokenRes.data.AuthToken]);

    const getWalletOwnerIdAndNameListTableRequest = () => {
        // setIsLoading(true);
        setWalletOwnerTableStatus(true);
        const getWalletOwnerIdAndNameListReq = {
            loginDetails: {
                // adminId: 2
                adminId: val.adminIDS
            }
        };
        dispatch(
            getWalletOwnerIdAndNameList(getWalletOwnerIdAndNameListReq, authToken)
        );
    };


    const getWalletOwnerListResFunc = () => {
        setRolesOnWalletOwner([])
        if (walletOwnerTableStatus) {
            if (getOwnerAndNameList.data.status == "success") {
                // setIsLoading(false);
                setWalletOwnerTableArray([].concat(getOwnerAndNameList.data.ownerList));
            }
            if (getOwnerAndNameList.data.status === "failed") {
                // setIsLoading(false);
                setWalletOwnerTableArray(getOwnerAndNameList.data.ownerList);
                if (
                    getOwnerAndNameList.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getOwnerAndNameList.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };

    useEffect(() => {
        getWalletOwnerListResFunc();
    }, [getOwnerAndNameList.data.status]);


    // const [getAllNotificationsStatus, getAllNotificationsStatus] = useState(false)
    // const [deleteMappingBankArray, setDeleteMappingBankArray] = useState("")
    const handleSearch = (role) => {
        console.log("ROLEESSSS", role);

        if (!role) {
            // setGetCongigNotificResArray({ status: "Failed", description: "Please Select Role" })

            // setNotificationOpen(true);
        }
        else {
            getNotificationConfigReq(role)

        }

    }

    //getPartnerWalletRoles

    const getRolesOnWalletOwnerReq = (walletOwnerId) => {
        const req = {

            authentication: {
                partnerId: walletOwnerId.split("-")[0]
            }

        }



        console.log("autht", authToken);
        dispatch(getPartnerWalletRoles(req, authToken))

    }

    useEffect(() => {
        setRolesOnWalletOwner(getWalletRolesRes.data.rolesList)
        console.log("rolesOnWalletOwnerRes", getWalletRolesRes);
    }, [getWalletRolesRes]);


    const getNotificationConfigReq = (value) => {

        console.log("getCongigNotificStatussss", getCongigNotificStatus)

        setGetCongigNotificStatus(true);
        const reqList = {

            actionCustomerMasterRequestVO: {
                walletOwnerId: walletOwner.split("-")[0] || "",
                role: value
            },

        }
        console.log("reqListAd", reqList);
        dispatch(getNotificationConfigsAdminList(reqList, authToken));
        console.log("i made get req");

        // getNotificationConfigsFunc()
        // console.log("REQUESTTTT", reqList)
        console.log("getCongigNotificStatussss1", getCongigNotificStatus)


    }

    useEffect(() => {
        console.log('status res: ', getNotificationConfigsAdminRes)
        console.log("i got get req data");
        if (getNotificationConfigsAdminRes) {

            getNotificationConfigsFunc();
        }
    }, [getNotificationConfigsAdminRes]);

    // useEffect(() => {
    //     console.log("inside useEffect", getAddUpdateNotificationConfigAdminRes)
    //     if (getAddUpdateNotificationConfigAdminRes.data.status) {
    //         getAddNotificationFunc();
    //     }
    // }, [getAddUpdateNotificationConfigAdminRes]);
    useEffect(() => {
        console.log("123res", getAddUpdateNotificationConfigAdminRes);
        if (getAddUpdateNotificationConfigAdminRes.data.status && role != "") {
            getAddNotificationFunc();
        }
    }, [getAddUpdateNotificationConfigAdminRes]);

    useEffect(() => {
        setGetMainArr([...defaultArr])
    }, [])

    const getNotificationConfigsFunc = () => {
        console.log("GETDATA", getNotificationConfigsAdminRes)
        console.log("getCongigNotificStatussss2", getCongigNotificStatus)

        // if (getCongigNotificStatus) {
        console.log("GETDATA1", getNotificationConfigsAdminRes)

        if (getNotificationConfigsAdminRes.data.status === "Success") {
            console.log("Latest arr inside for success", getNotificationConfigsAdminRes.data.list)
            setGetDataCompare([...getNotificationConfigsAdminRes.data.list])
            // setGetCongigNotificResArray([].concat(getNotificationConfigsAdminRes.data.list))
            setCheckListNotification(true)
            setGetMainArr([...getNotificationConfigsAdminRes.data.list])

            setAddOrEditStatus("edit")
            setGetCongigNotificStatus(false)
        }
        if (getNotificationConfigsAdminRes.data.status === "Failed") {
            console.log("Latest arr inside", getNotificationConfigsAdminRes.data.list)
            // setGetCongigNotificResArray(getNotificationConfigsAdminRes.data)
            console.log("Failed: ", getNotificationConfigsAdminRes.data);
            console.log('defaultArr: ', defaultArr)
            setGetMainArr([...defaultArr]);
            setGetDataCompare([...defaultArr])

            setCheckListNotification(true)
            setAddOrEditStatus("add")
            setGetCongigNotificStatus(false)

        }
        if (getNotificationConfigsAdminRes.data.status === "failed") {
            // setGetCongigNotificResArray(getNotificationConfigsAdminRes.data)
            setGetMainArr([...defaultArr])
            setGetDataCompare([...defaultArr])

            setCheckListNotification(true)
            setAddOrEditStatus("add")
            setGetCongigNotificStatus(false)

        }
        // }



    }
    // useEffect(() => {
    //     getNotificationConfigsFunc()
    // }, [getNotificationConfigsAdminRes.data.status])

    // useEffect(() => {
    //     if (regenerateTokenRes.data.status == "success") {
    //         getNotificationConfigsFunc()
    //     }
    // }, [regenerateTokenRes.data.status]);

    let defaultArr = [{
        "id": "",
        "transactionType": "LOAD",
        "noneNotification": "N",
        "pushNotification": "N",
        "smsNotification": "N",
        "emailNotification": "N"
    },
    {
        "id": "",
        "transactionType": "TRANSFER",
        "noneNotification": "N",
        "pushNotification": "N",
        "smsNotification": "N",
        "emailNotification": "N"
    },
    // {
    //     "id": "",
    //     "transactionType": "SEND",
    //     "noneNotification": "N",
    //     "pushNotification": "N",
    //     "smsNotification": "N",
    //     "emailNotification": "N"
    // },
    {
        "id": "",
        "transactionType": "PURCHASE",
        "noneNotification": "N",
        "pushNotification": "N",
        "smsNotification": "N",
        "emailNotification": "N"
    },
    {
        "id": "",
        "transactionType": "REFUND",
        "noneNotification": "N",
        "pushNotification": "N",
        "smsNotification": "N",
        "emailNotification": "N"
    },
    // {
    //     "id": "",
    //     "transactionType": "RECEIVED",
    //     "noneNotification": "N",
    //     "pushNotification": "N",
    //     "smsNotification": "N",
    //     "emailNotification": "N"
    // },
    {
        "id": "",
        "transactionType": "WITHDRAW",
        "noneNotification": "N",
        "pushNotification": "N",
        "smsNotification": "N",
        "emailNotification": "N"
    },

    ]

    const [getMainArr, setGetMainArr] = useState([...defaultArr])

    // const [newArray, setNewArray] = useState([])

    const handleChangeBase = (e, index) => {
        setGetDataCompare([])
        // console.log("NEWARRR", newArray)

        // if (!newArray.includes(index)) {
        //     setNewArray([...newArray, index])

        // }

        const name = e.target.name
        const CheckValue = e.target.checked
        let ChangeValue = CheckValue === true ? "D" : "N"
        console.log("CHECKVALUEEE", CheckValue)
        console.log("CHANGEVAL", ChangeValue)
        // console.log("CHECKVALUEEEE", CheckValue)
        console.log("TransactionTYPE", name)
        if (name == "noneNotification") {

            for (let i in getMainArr[index]) {
                if (i == name || i == "transactionType" || i == "id") {
                    continue
                }

                else {
                    getMainArr[index][i] = ChangeValue
                }
            }

        }
        if (name != "noneNotification") {
            getMainArr[index]["noneNotification"] = "D"
        }
        // if (getMainArr[index]["PushNotification"] === "N" && getMainArr[index]["SMS"] === "N" && getMainArr[index]["Email"] === "N") {
        //     getMainArr[index]["None"] = "N"
        // }

        getMainArr[index][name] = CheckValue ? "Y" : "N"
        console.log("MainARRRAAAYY", getMainArr)
        setGetMainArr([...getMainArr])
        if (getMainArr[index]["pushNotification"] === "N" && getMainArr[index]["smsNotification"] === "N" && getMainArr[index]["emailNotification"] === "N") {
            getMainArr[index]["noneNotification"] = "N"
        }
    }
    console.log("addres", getAddUpdateNotificationConfigAdminRes);
    const getAddNotificationFunc = () => {

        console.log("USESELec", getAddUpdateNotificationConfigAdminRes)

        if (getAddUpdateNotificationConfigAdminRes.data.status === "success") {

            console.log("getAddUpdateNotificationConfigAdminRessssss", getAddUpdateNotificationConfigAdminRes.data)
            setGetCongigNotificResArray(getAddUpdateNotificationConfigAdminRes.data)

            setNotificationOpen(true);

            console.log("am making get req");

            // getNotificationConfigReq()
            // setTimeout(() => {
            console.log("INSIDE timeout")
            handleSearch(role)
            console.log("AFter handlesearch")

            // }, 2000)




            console.log("FINALRESPONSEDATA", getAddUpdateNotificationConfigAdminRes.data.customerMasterDetailsRequestVOList)

            // setGetMainArr([].concat(getAddUpdateNotificationConfigAdminRes.data.customerMasterDetailsRequestVOList));
            // getNotificationConfigReq()

        }
        if (getAddUpdateNotificationConfigAdminRes.data.status === "failed") {
            console.log("DATTTAAAA", getAddUpdateNotificationConfigAdminRes)

            setGetCongigNotificResArray(getAddUpdateNotificationConfigAdminRes.data)

            setNotificationOpen(true);

            // setGetMainArr(getAddUpdateNotificationConfigAdminRes.data);
            if (
                getAddUpdateNotificationConfigAdminRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            if (
                getAddUpdateNotificationConfigAdminRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }

        }
        if (getAddUpdateNotificationConfigAdminRes.data.status === "Failed") {
            setGetCongigNotificResArray(getAddUpdateNotificationConfigAdminRes.data)
            setNotificationOpen(true);
            getNotificationConfigsFunc()
            // setGetMainArr(getAddUpdateNotificationConfigAdminRes.data);
            if (
                getAddUpdateNotificationConfigAdminRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            if (
                getAddUpdateNotificationConfigAdminRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
    }
    const getAddNotificationListReq = () => {
        if (!walletOwner) {
            setGetCongigNotificResArray({ status: "Failed", description: "Please Select Wallet Owner ID" })

            setNotificationOpen(true);
            return;
        }
        if (!role) {
            setGetCongigNotificResArray({ status: "Failed", description: "Please Select Role" })

            setNotificationOpen(true);
            return;
        }
        console.log("checkkkk", getMainArr, getDataCompare);

        if (addOrEditStatus === "add") {
            if (JSON.stringify(getMainArr) == JSON.stringify(getDataCompare)) {
                setGetCongigNotificResArray({ status: "Failed", description: "Please Select the Notification Type" })

                setNotificationOpen(true);
                return;

            }
            const req = {
                loginDetails: {
                    walletOwnerId: walletOwner.split("-")[0] || "",
                    role: role
                },
                customerMasterDetailsRequestVOList: getMainArr
            }

            dispatch(addUpdateNotificationConfigAdminLists(req, authToken));
            // getAddNotificationFunc()

        }
        else {
            if (JSON.stringify(getMainArr) == JSON.stringify(getDataCompare)) {
                setGetCongigNotificResArray({ status: "Failed", description: "No Changes Found" })

                setNotificationOpen(true);
                return;
            }
            const request = {
                loginDetails: {
                    walletOwnerId: walletOwner.split("-")[0] || "",
                    role: role
                },
                customerMasterDetailsRequestVOList: getMainArr
            }
            // console.log("EDIT REQUEST", request)

            dispatch(addUpdateNotificationConfigAdminLists(request, authToken));
            // getAddNotificationFunc()


        }

        // console.log("NOTIFICATIONSS", req)

        // console.log("FINALMAINARR", getMainArr)
        // let getNotiFicationIndex = []
        // for (let i = 0; i < getMainArr.length; i++) {
        //     console.log("inside for", getMainArr[i])
        //     for (let key in getMainArr[i]) {
        //         if (getMainArr[i][key] === "Y") {
        //             getMainArr[i].id = ""
        //             getNotiFicationIndex.push(getMainArr[i])

        //             break

        //         }

        //     }

        // }
        // console.log("FINALINDEX", getNotiFicationIndex)


    };



    // useEffect(() => {

    //     getAddNotificationFunc();

    // }, [getAddUpdateNotificationConfigAdminRes.data.status]);






    return (
        <>
            <Layout>
                <BackButton />
                <Card>
                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px" }}
                    >

                        <Grid
                            container
                            spacing={2}
                            style={{ padding: "5px", marginTop: "0px" }}
                        >
                            <Grid item sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    autoFocus
                                    margin="dense"
                                    id="name"
                                    label="Owner ID"
                                    type="name"
                                    fullWidth
                                    variant="standard"
                                    name="walletOwner"
                                    onChange={handleChangeWallet}
                                    // value={walletOwner || "Select Owner ID"}
                                    defaultValue={"Select Owner ID" || walletOwner}
                                >
                                    <MenuItem value="Select Owner ID" selected="Select Owner ID">
                                        Select Owner ID
                                    </MenuItem>
                                    {getOwnerAndNameList.data.ownerList &&
                                        getOwnerAndNameList.data.ownerList &&
                                        []
                                            .concat(getOwnerAndNameList.data.ownerList)
                                            .map((dropdown) => (
                                                <MenuItem value={dropdown}>{dropdown}</MenuItem>
                                            ))}
                                </TextField>
                            </Grid>
                            {/* <Grid item sm={12} md={4} lg={4}>
						<Button
							style={{
								marginLeft: "0.7rem",
								backgroundColor: "#00b9f5",
								color: "white",
								marginTop: "17px"
							}}
							endIcon={<AiOutlineSearch />}
							variant="contained"
							onClick={getWalletOwnerIdAndNameListApiReq}
						>
							Search
						</Button>
					</Grid> */}

                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <TextField
                                    select
                                    // autoFocus
                                    margin="dense"
                                    id="name"
                                    label="Select Role"
                                    fullWidth
                                    variant="standard"
                                    type="text"
                                    name="role"
                                    defaultValue={role}
                                    onChange={handleChange}
                                >
                                    {/* <MenuItem selected="Select Role">
                                    Select Role
                                </MenuItem> */}

                                    {console.log("rolesOnWalletOwner", rolesOnWalletOwner)}
                                    {!rolesOnWalletOwner ? <MenuItem value={""}>{"No Roles Found"}</MenuItem> : rolesOnWalletOwner &&
                                        (<MenuItem
                                            value="Select Role"
                                            selected="Select Role"
                                        >
                                            Select Role
                                        </MenuItem> && rolesOnWalletOwner.map((x) => (
                                            <MenuItem value={x}>{x}</MenuItem>
                                        )))}
                                </TextField>
                            </Grid>



                        </Grid>

                        {/* <Grid item xs={12} sm={12} md={4} lg={4} container>
                            <Grid>
                                <CustomButton
                                    style={{
                                        padding: "8px"
                                    }}
                                    // onClick={handleSearch}
                                >
                                    Search <SearchIcon />
                                </CustomButton>
                            </Grid>

                        </Grid> */}

                    </Grid>
                </Card>

                <Card>
                    <Grid
                        container
                        style={{
                            padding: "10px"
                        }}
                    >
                        <Grid xs={12} sm={12} md={12} lg={12}>
                            <Typography
                                variant="body1"
                                style={{ fontWeight: "700" }}
                                className="themeText"
                            >
                                Notification
                            </Typography>
                        </Grid>
                        <TableContainer component={Paper} className="my-3">
                            <Table
                                className={classes.table}
                                size="small"
                                aria-label="a dense table"
                            >
                                <TableHead>
                                    <TableRow className="tableHeaderColor">
                                        <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold", color: "white" }}
                                        >
                                            Transaction Type{" "}
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold", color: "white" }}
                                        >
                                            None{" "}
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold", color: "white" }}
                                        >
                                            PUSH Notification
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold", color: "white" }}
                                        >
                                            SMS
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold", color: "white" }}
                                        >
                                            EMAIL
                                        </TableCell>



                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {getMainArr.map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell align="center">
                                                {row.transactionType}
                                            </TableCell>
                                            <TableCell align="center">
                                                {/* {row.None} */}
                                                <input type="checkbox" name="noneNotification" checked={row.noneNotification === "Y" ? true : false} disabled={row.noneNotification === "D"} onChange={(e) => { handleChangeBase(e, index) }} />

                                            </TableCell>
                                            <TableCell align="center">
                                                {/* {row.PushNotification} */}
                                                <input type="checkbox" name="pushNotification" checked={row.pushNotification === "Y" ? true : false}
                                                    disabled={row.pushNotification === "D"}
                                                    onChange={(e) => { handleChangeBase(e, index) }} />

                                            </TableCell>
                                            <TableCell align="center">
                                                {/* {row.SMS} */}
                                                <input type="checkbox" name="smsNotification" checked={row.smsNotification === "Y" ? true : false}
                                                    disabled={row.smsNotification === "D"}

                                                    onChange={(e) => { handleChangeBase(e, index) }} />

                                            </TableCell>
                                            <TableCell align="center">
                                                {/* {row.Email} */}
                                                <input type="checkbox" name="emailNotification" checked={row.emailNotification === "Y" ? true : false}
                                                    disabled={row.emailNotification === "D"}

                                                    onChange={(e) => { handleChangeBase(e, index) }} />

                                            </TableCell>

                                        </TableRow>

                                    ))}
                                </TableBody>

                            </Table>

                        </TableContainer>
                        <CustomButton
                            style={{
                                padding: "8px",
                                marginLeft: "50%"
                            }}
                            onClick={getAddNotificationListReq}
                            endIcon={<SaveIcon />}
                        >
                            Save <SaveIcon />
                        </CustomButton>
                    </Grid>
                </Card>

            </Layout>





            {console.log("Inside code and response", getCongigNotificResArray)}
            {getCongigNotificResArray.status == "success" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center lightThemeBackground"
                        // style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {getCongigNotificResArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            {/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {getCongigNotificResArray.status == "failed" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center lightThemeBackground"
                        // style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {getCongigNotificResArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            {/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {getCongigNotificResArray.status == "Failed" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center lightThemeBackground"
                        // style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {getCongigNotificResArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            {/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
        </>
    )
}

export default AdminPushNotification